export default {
  label: {
    today: ' today',
    yesterday: ' yesterday',
    toMonth: '   this month',
    todayDetails: 'details today',
    yesterdayDetails: 'details yesterday',
    toMonthDetails: 'details this month',
    focusinfo: 'general information',
    amountOfFail: ' total of failures',
    amountOfProfit: 'interest',
    amountOfSuccess: 'total successful money',
    amountOfTotal: 'total transaction amount',
    paymentNumberOfSuccess: '代收成功单数',
    payoutNumberOfSuccess: '代付成功单数',
    paymentNumberOfFail: '代收失败单数',
    payOutNumberOfFail: '代付失败单数',
    paymentNumberOfTotal: '代收总单数',
    payoutNumberOfTotal: '代付总单数',
    paymentAmountOfSuccess: '代收成功金额',
    payoutAmountOfSuccess: '代付成功金额',
    paymentAmountOfFail: '代收失败金额',
    payoutAmountOfFail: '代付失败金额',
    paymentAmountOfTotal: '代收总金额',
    payoutAmountOfTotal: '支付总额',
    channel: 'payment channel',
    dateByDay: 'date ',
    dateByMonth: ' month',
    dateType: ' time',
    id: 'ID',
    numberOfFail: 'single sum failed ',
    numberOfSuccess: 'total successful application',
    numberOfTotal: 'total application',
    owner: 'owner',
    updateTime: ' update time',
    userType: 'account type',
    successRate: 'Success rate',
    MerchantBalance:'Merchant balance'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/welcome.js